import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
const DEVICE_ID = "deviceId";
const REFRESH_TOKEN = "refreshToken";

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  public isLoggedIn$ = new BehaviorSubject<boolean>(this.getToken() !== null);

  constructor() { }

  signOut(): void {
    window.localStorage.clear();
  }

  public saveToken(token: string): void {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.setItem(TOKEN_KEY, token);
    this.isLoggedIn$.next(true);
  }

  public getToken(): string | null {
    const token = window.localStorage.getItem(TOKEN_KEY);
    if (token === 'null' || !token) {
      return null;
    }
    return token;
  }

  public saveUser(user: any): void {
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any {
    const user = window.localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }

    return {};
  }

  public saveDeviceId(deviceId: string) {
    window.localStorage.removeItem(DEVICE_ID);
    window.localStorage.setItem(DEVICE_ID, deviceId);
  }

  public getDeviceId(): string {
    let deviceId = window.localStorage.getItem(DEVICE_ID);
    if (!deviceId) {
      deviceId = self.crypto.randomUUID();
      this.saveDeviceId(deviceId);
    }
    return deviceId;
  }

  public saveRefreshToken(refreshToken: string) {
    window.localStorage.removeItem(REFRESH_TOKEN);
    window.localStorage.setItem(REFRESH_TOKEN, refreshToken);
  }

  public getRefreshToken() {
    const refreshToken = window.localStorage.getItem(REFRESH_TOKEN);
    if (refreshToken && refreshToken !== 'null') {
      return refreshToken;
    } else return null
  }
}